import React, { FC, useState } from 'react'

import { Txt, Modal, StandardButton } from 'src/components/atoms'

import { useGetCompany, useGetSamlIdp, useSamlIdp, useToast } from 'src/hooks'

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const SamlResetModal: FC<Props> = ({ isOpen, onClose }) => {
  const { company } = useGetCompany()
  const { samlIdp, refetch } = useGetSamlIdp()

  const [isLoading, setIsLoading] = useState(false)

  const { deleteSamlIdp } = useSamlIdp()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const handleOnReset = async () => {
    setIsLoading(true)

    try {
      if (!company || !samlIdp?.samlIdp.id) {
        throw new Error('予期せぬエラーが発生しました')
      }

      await deleteSamlIdp(company.id, samlIdp.samlIdp.id)
      displayStandardTextToast('IdP設定を削除しました')
      refetch()

      onClose()
    } catch {
      displayErrorTextToast('IdP設定の削除に失敗しました')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="md">
      <div className="tw-w-[30.86rem] tw-p-s2">
        <Txt className="tw-font-bold tw-text-standardText-primary !tw-text-3xl tw-text-center">
          リセット
        </Txt>
        <Txt sizeType="l" className="tw-mt-s1 tw-text-center">
          「サインアウトフロー・メタデータ・属性マッピング」の設定がリセットされます。
        </Txt>

        <div className="tw-centering tw-mt-s3">
          <StandardButton
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            buttonType="danger"
            text="決定"
            prependIconPath="check/soft/line"
            isLoading={isLoading}
            size="l"
            onClick={handleOnReset}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
